module.exports = __webpack_public_path__ + "static/media/ipk2022_Branding.006.b23a8577.jpeg";